import React from "react";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { Modal } from "reactstrap";
import { useDebouncedCallback } from "use-debounce";

import { ColoredButton, WhiteButton } from "../../../styledComponents/buttons";
import { CommonText, InputTextArea } from "../../../styledComponents/common";
import { ModalButtonSection } from "../../../styledComponents/members";

const SupervisorModal = ({
  isOpen,
  toggle,
  isLoading,
  rejectedJobInfo,
  updateTaskStatusRequest,
}) => {
  const { t } = useTranslation();
  const [supervisorNote, setSupervisorNote] = useState("");

  const handleNoteChange = e => {
    setSupervisorNote(e.target.value);
  };

  const handleReject = useDebouncedCallback(() => {
    if (updateTaskStatusRequest && rejectedJobInfo) {
      updateTaskStatusRequest(
        rejectedJobInfo.id,
        rejectedJobInfo.approval,
        rejectedJobInfo.type,
        supervisorNote,
      );
      setSupervisorNote("");
      toggle();
    }
  }, 500);

  return (
    <Modal
      style={{ marginTop: "140px", zIndex: "10" }}
      isOpen={isOpen}
      toggle={() => {
        setSupervisorNote("");
        toggle();
      }}
    >
      <div style={{ padding: "20px" }}>
        <CommonText name title fontSize="16px" margin="auto 0 10px 0">
          {t("supervisor_note")}
        </CommonText>
        <InputTextArea
          style={{ width: "100%", height: "120px" }}
          placeholder="Enter your note here..."
          onChange={handleNoteChange}
        />
        <ModalButtonSection>
          <WhiteButton
            type="cancel"
            onClick={() => {
              setSupervisorNote("");
              toggle();
            }}
          >
            Cancel
          </WhiteButton>
          <ColoredButton
            type="delete"
            padding={isLoading ? "0 15px" : "0 30px"}
            onClick={() => handleReject()}
          >
            Reject
          </ColoredButton>
        </ModalButtonSection>
      </div>
    </Modal>
  );
};

export default SupervisorModal;
